import React, {forwardRef, memo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {TextInput, Button, Theme, ThemeName} from '@taopix/taopix-design-system';

export type AssetServiceNavSearchProps = {
  onSubmit: (str: string) => void;
};

const AssetServiceNavSearch = forwardRef<HTMLInputElement, AssetServiceNavSearchProps>(
  (props, ref) => {
    const {t} = useTranslation(['*']);
    const [str, setStr] = useState('');

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setStr(e.target.value);
    };

    return (
      <Theme name={ThemeName.Container} className="flex justify-start space-x-sm p-xs mb-sm">
        <TextInput
          type="text"
          placeholder={t('assetservices:str_LabelSearchTerm')}
          name="librarylink_search"
          id="librarylink_search"
          autoFocus
          defaultValue=""
          className="w-[200rem]"
          onChange={onChange}
          ref={ref}
        />
        <Button
          onClick={() => props.onSubmit(str)}
          size="small"
          buttonStyle="secondary"
          label={t('assetservices:str_LabelSearch')}
        />
      </Theme>
    );
  }
);

export default memo(AssetServiceNavSearch);
